import { render, staticRenderFns } from "./AddTvDialog.vue?vue&type=template&id=e98798a6"
import script from "./AddTvDialog.vue?vue&type=script&lang=js"
export * from "./AddTvDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports